import React from 'react';

import { Chord } from '@ant-design/charts';
import WidgetEchartConfig from './WidgetEchartConfig'

class WidgetEchartChord extends React.Component 
{
    constructor()
    {
        super();

        this.onEvent = this.onEvent.bind(this);
        this.buildConfig = this.buildConfig.bind(this);
    }

    /** event */
    onEvent(chart, event) 
    {
        if( this.props.onEvent!==undefined )
        {
            if( event.type==="element:mousedown" )
            {
                let { data } = chart.options;

                if( data!==undefined && data.length>0 )
                {
                    for( let i=0; i<data.length; i++)
                    {
                        let item = event.data.data;

                        if( item.name!==undefined )
                        {
                            if( data[i][chart.options.sourceField]===item.name )
                            {
                                this.props.onEvent( event, data[i] );
                                break;
                            }
                        }
                        else
                        {
                            if( data[i][chart.options.sourceField]===item.source  && data[i][chart.options.targetField]===item.target )
                            {
                                this.props.onEvent( event, data[i] );
                                break;
                            }
                        }
                    }
                } 
            } 
        }
    }

    /** create config */
    buildConfig(option, data)
    {   
        let config = {
            data : data.data,
            sourceField: option.xField!==undefined ? option.xField.name : 'name',
            targetField: option.sField!==undefined ? option.sField.name : 'sname',
            weightField: option.yField!==undefined ? option.yField.name : 'value',
        };

        if( option.theme!==undefined )
        {
            config = {...WidgetEchartConfig.theme[option.theme].chordConfig, ...option, ...config};
        }
        else
        {
            config = {...WidgetEchartConfig.theme["default"].chordConfig, ...option, ...config};
        }

        return config;
    }

    render()
    {
        const { option, data } = this.props; 
        
        let config = this.buildConfig(option, data);

        return <Chord {...config} onEvent={this.onEvent}></Chord> 
    }
}

export default WidgetEchartChord;